import { SafeAreaProvider } from 'react-native-safe-area-context';
import MetroScreen from './app/index';

export default function App() {
  return (
    <SafeAreaProvider>
      <MetroScreen />
    </SafeAreaProvider>
  );
}
